import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import styled from "styled-components";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import SearchBar from "./../../../component/atoms/input/searchBar";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import Table from "../../../component/atoms/layout/table/table";
import Tr from "./../../../component/atoms/layout/table/tr";
import Th from "./../../../component/atoms/layout/table/th";
import Checkbox from "./../../../component/atoms/input/checkbox";
import TableText from "./../../../component/atoms/text/table/tableText";
import DetailBtn from "./../../../component/atoms/button/detailBtn";
import PretendardText from "../../../component/atoms/text/pretendardText";
import Td from "./../../../component/atoms/layout/table/td";
import TableCount from "./../../../component/molecules/tableCount";
import Pagination from "./../../../component/molecules/pagination";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import SubSideBar from "../../../component/organisms/subSideBar";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import { route } from "../../../router/route";
import GroupManagePopup from "../../../component/templates/user/userInfo/groupManagePopup";
import GroupApi from "../../../api/group.api";
import { errorHandler } from "../../../util/errorHandler";
import MemberApi from "../../../api/member.api";
import AlarmSendPopup from "../../../component/templates/user/userInfo/alarmSendPopup";
import SMSSendPopup from "../../../component/templates/user/userInfo/smsSendPopup";
import ListTopButtonGroup from "../../../component/templates/user/userInfo/listTopButtonGroup";
import { cMembershipList } from "../../../constants/userInfoConstants";
import SelectBoxValue from "../../../component/organisms/selectBoxValue";
import Empty from "../../../component/molecules/empty";
import { toast } from "react-toastify";
import { formatNumberWithCommas } from "../../../util/formatNumber";
import ExcelApi from "../../../api/excel.api";
import { saveAs } from "file-saver";

// sessionStorage 초기화
function sessionStorageInit() {
  sessionStorage.removeItem("sCheckedListStorage");
  const event = new Event("sessionStorageChange");
  window.dispatchEvent(event);
}

const UserInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.user_info)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [keyword, setKeyword] = useState("");

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  // ---------- 행 수 관련 ---------- //
  const [selectedRowsPerPage, setSelectedRowsPerPage] = useState("10");
  const [rowsPerPageListBoxOpen, setRowsPerPageListBoxOpen] = useState(false);
  const rowsPerPageList = [
    {
      title: "10명씩",
      value: "10",
    },
    {
      title: "30명씩",
      value: "30",
    },
    {
      title: "50명씩",
      value: "50",
    },
    {
      title: "100명씩",
      value: "100",
    },
  ];

  // ---------- 정렬방식 관련 ---------- //
  const [selectedSort, setSelectedSort] = useState("createdAt");
  const [sortListBoxOpen, setSortListBoxOpen] = useState(false);
  const sortList = [
    {
      title: "가입순",
      value: "createdAt",
    },
    {
      title: "포인트순",
      value: "totalPoint",
    },
    {
      title: "누적구매순",
      value: "purchaseCount",
    },
    {
      title: "최근접속순",
      value: "updatedAt", //최근접속순
    },
  ];

  const [groupPopupOpen, setGroupPopupOpen] = useState(false);
  const [alarmPopupOpen, setAlarmPopupOpen] = useState(false);
  const [smsPopupOpen, setSMSPopupOpen] = useState(false);

  // 새로추가된 부분
  const [selectedGroupValue, setSelectedGroupValue] = useState();
  const [selectedGroupId, setSelectedGroupId] = useState(0);
  const [normalGroupList, setNormalGroupList] = useState([]);
  const [operateGroupList, setOperateGroupList] = useState([]);

  // ---------- 데이터 관련 ---------- //
  const [userInfoList, setUserInfoList] = useState([]);

  useEffect(() => {
    getNormalGroupList();
    getOperateGroupList();

    return () => {
      sessionStorage.removeItem("sCheckedListStorage");
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    setSelectedGroupId(
      searchParams.get("groupId") ? Number(searchParams.get("groupId")) : 0
    );
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    setSelectedSort(
      searchParams.get("sort") ? searchParams.get("sort") : "createdAt"
    );
    setSelectedRowsPerPage(
      searchParams.get("perPage") ? searchParams.get("perPage") : "10"
    );

    getMemberList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  // 일반 그룹 가져오기
  const getNormalGroupList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        memberGroupType: "NORMAL",
      };

      const response = (await GroupApi.getList(data)).data.data.content;
      setNormalGroupList(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 운영진 그룹 가져오기
  const getOperateGroupList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        memberGroupType: "OPERATE",
      };

      const response = (await GroupApi.getList(data)).data.data.content;
      setOperateGroupList(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    if (selectedGroupValue) {
      setGroupPopupOpen(true);
    }
  }, [selectedGroupValue]);

  const getMemberList = async () => {
    try {
      const data = {
        page: Number(page),
        size: searchParams.get("perPage")
          ? Number(searchParams.get("perPage"))
          : pagination.size,
        orderBy: "DESC",
      };

      if (searchParams.get("groupId")) {
        data.groupId = Number(searchParams.get("groupId"));
      }

      if (searchParams.get("keyword")) {
        data.keyword = searchParams.get("keyword");
      }

      if (searchParams.get("sort")) {
        data.sort = searchParams.get("sort");
      }

      const response = (await MemberApi.getList(data)).data.data;

      const processedResponse = [...response.content].map((item) => {
        if (item.age === null) {
          item.age = "-";
        } else {
          const year = item.age.split("-")[0];
          const currentYear = new Date().getFullYear();
          const koreanAge = currentYear - year + 1;

          if (koreanAge < 10) {
            item.age = "10대 미만";
          } else if (koreanAge < 20) {
            item.age = "10대";
          } else if (koreanAge < 30) {
            item.age = "20대";
          } else if (koreanAge < 40) {
            item.age = "30대";
          } else if (koreanAge < 50) {
            item.age = "40대";
          } else if (koreanAge < 60) {
            item.age = "50대";
          } else if (koreanAge >= 60) {
            item.age = "60대 이상";
          }
        }

        return {
          ...item,
          checked: false,
        };
      });

      setUserInfoList(processedResponse);

      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(
          response.totalCount /
            (searchParams.get("perPage")
              ? Number(searchParams.get("perPage"))
              : pagination.size)
        ),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  // ========== 체크박스 관련 ========== //
  const sessionStorageCheckedList = sessionStorage.getItem(
    "sCheckedListStorage"
  );
  const [checkedListStorage, setCheckedListStorage] = useState([]);
  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);
  const [isAllCheck, setIsAllCheck] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCheckedListStorage(
        sessionStorageCheckedList ? JSON.parse(sessionStorageCheckedList) : []
      );
    };

    window.addEventListener("sessionStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("sessionStorageChange", handleStorageChange);
    };
  }, []); // eslint-disable-line

  useEffect(() => {
    sessionStorage.setItem(
      "sCheckedListStorage",
      JSON.stringify(checkedListStorage)
    );
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (userInfoList.length > 0) {
      const idsInArray1 = new Set(checkedListStorage.map((item) => item.id));

      const allIdsIncluded = userInfoList.every((item) =>
        idsInArray1.has(item.id)
      );

      setIsAllCheck(allIdsIncluded);
    }

    if (checkedListStorage.length > 0) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }
  }, [checkedListStorage, userInfoList]); /// eslint-disable-line react-hooks/exhaustive-deps

  // ========== 엑셀 관련 ========== //
  // 엑셀 생성
  const downloadExcel = async (excelData) => {
    const Excel = require("exceljs");
    const workbook = new Excel.Workbook();
    workbook.addWorksheet("Sheet One");
    const sheetOne = workbook.getWorksheet("Sheet One");

    sheetOne.columns = [
      { header: "이름", key: "name", width: 20 },
      { header: "이메일", key: "email", width: 20 },
      { header: "연령", key: "age", width: 20 },
      { header: "성별", key: "gender", width: 20 },
      { header: "그룹", key: "groupList", width: 20 },
      { header: "회원등급", key: "membership", width: 20 },
      { header: "레벨", key: "writingLevel", width: 20 },
      { header: "누적 구매수", key: "purchaseCount", width: 20 },
      { header: "누적 구매액", key: "purchaseAmount", width: 20 },
      { header: "보유 포인트", key: "totalPoint", width: 20 },
    ];

    excelData.map((item) => {
      // 행 추가
      sheetOne.addRow(item);
      return null;
    });
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "회원 정보.xlsx");
  };

  const calcAge = (birth) => {
    if (birth === null) {
      return "-";
    } else {
      const year = birth.split("-")[0];
      const currentYear = new Date().getFullYear();
      const koreanAge = currentYear - year + 1;

      if (koreanAge < 10) {
        return "10대 미만";
      } else if (koreanAge < 20) {
        return "10대";
      } else if (koreanAge < 30) {
        return "20대";
      } else if (koreanAge < 40) {
        return "30대";
      } else if (koreanAge < 50) {
        return "40대";
      } else if (koreanAge < 60) {
        return "50대";
      } else if (koreanAge >= 60) {
        return "60대 이상";
      }
    }
  };

  const getExcelAll = async () => {
    try {
      const excelArr = [];
      const response = (
        await ExcelApi.getMemberExcel({
          ids: [],
          allFlag: true,
        })
      ).data.data.content;

      response.map((item) => {
        const groupList =
          item?.groupList?.map((group) => group.title).join(", ") ||
          "그룹 없음";
        const age = calcAge(item.age);
        const gender = item.gender === "male" ? "남" : "여";
        const membership = cMembershipList[item.membership];
        excelArr.unshift({ ...item, groupList, age, gender, membership });
        return null;
      });

      downloadExcel(excelArr);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getExcelChecked = async () => {
    if (checkedListStorage.length < 1) {
      return toast("항목을 선택해주세요");
    }

    try {
      const excelArr = [];
      const response = (
        await ExcelApi.getMemberExcel({
          ids: checkedListStorage.map((item) => item.id),
          allFlag: false,
        })
      ).data.data.content;

      response.map((item) => {
        const groupList =
          item?.groupList?.map((group) => group.title).join(", ") ||
          "그룹 없음";
        const age = calcAge(item.age);
        const gender = item.gender === "male" ? "남" : "여";
        const membership = cMembershipList[item.membership];
        excelArr.unshift({ ...item, groupList, age, gender, membership });
        return null;
      });

      downloadExcel(excelArr);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ========== 기타 ========== //
  const initRoute = () => {
    navigate(
      `${route.user_info}?page=1&groupId=${selectedGroupId}&sort=${selectedSort}&perPage=${selectedRowsPerPage}&keyword=${keyword}`
    );
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 사이드 바 영역 */}
        <SubSideBar title="회원 그룹">
          <SubSideBarItem
            selected={selectedGroupId === 0 ? true : false}
            onClick={() => {
              if (selectedGroupId === 0) return;

              sessionStorageInit();
              navigate(
                `${route.user_info}?page=1&groupId=0&sort=&perPage=&keyword=`
              );
            }}
          >
            전체
          </SubSideBarItem>
          <SubSideBarItem
            selected={selectedGroupId === -1 ? true : false}
            onClick={() => {
              if (selectedGroupId === -1) return;

              sessionStorageInit();
              navigate(
                `${route.user_info}?page=1&groupId=-1&sort=&perPage=&keyword=`
              );
            }}
          >
            그룹 없음
          </SubSideBarItem>
          {normalGroupList.length > 0
            ? normalGroupList.map((item, index) => {
                return (
                  <SubSideBarItem
                    selected={selectedGroupId === item.id ? true : false}
                    onClick={() => {
                      if (selectedGroupId === item.id) return;

                      sessionStorageInit();
                      navigate(
                        `${route.user_info}?page=1&groupId=${item.id}&sort=&perPage=&keyword=`
                      );
                    }}
                    key={index}
                    icon="setting"
                    settingHandler={() => {
                      if (isWriteAuthority) {
                        setSelectedGroupValue(item);
                      } else {
                        toast("권한이 없습니다.");
                      }
                    }}
                  >
                    {item.title}
                  </SubSideBarItem>
                );
              })
            : null}

          {operateGroupList.length > 0 && (
            <span
              style={{
                width: "100%",
                height: 0.5,
                background: "rgba(255, 255, 255, 0.12)",
              }}
            />
          )}

          {operateGroupList.length > 0
            ? operateGroupList.map((item, index) => {
                return (
                  <SubSideBarItem
                    selected={selectedGroupId === item.id ? true : false}
                    key={index}
                    icon="setting"
                    onClick={() => {
                      if (selectedGroupId === item.id) return;

                      sessionStorageInit();
                      navigate(
                        `${route.user_info}?page=1&groupId=${item.id}&sort=&perPage=&keyword=`
                      );
                    }}
                    settingHandler={() => {
                      if (isWriteAuthority) {
                        setSelectedGroupValue(item);
                      } else {
                        toast("권한이 없습니다.");
                      }
                    }}
                  >
                    {item.title}
                  </SubSideBarItem>
                );
              })
            : null}
          {isWriteAuthority && (
            <SubSideBarFooter>
              <SubSideBarFooterText
                onClick={() => {
                  setSelectedGroupValue({
                    id: 0,
                  });
                }}
              >
                새 그룹 만들기
              </SubSideBarFooterText>
            </SubSideBarFooter>
          )}
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>회원정보</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount text={"회원"} count={pagination.totalCount} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"이름, 아이디(이메일), 닉네임"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    sessionStorageInit();
                    navigate(
                      `${route.user_info}?page=1&groupId=${selectedGroupId}&sort=${selectedSort}&perPage=${selectedRowsPerPage}&keyword=${keyword}`
                    );
                  }
                }}
                onClick={() => {
                  sessionStorageInit();
                  navigate(
                    `${route.user_info}?page=1&groupId=${selectedGroupId}&sort=${selectedSort}&perPage=${selectedRowsPerPage}&keyword=${keyword}`
                  );
                }}
              />
              <ExcelBtn
                onSelectClick={getExcelChecked}
                onAllClick={getExcelAll}
              />
              <SelectBoxValue
                isMiddle={true}
                selectedValue={selectedSort}
                isOpen={sortListBoxOpen}
                wrapperHandler={() => {
                  setSortListBoxOpen(!sortListBoxOpen);
                }}
                itemList={sortList}
                selectedValueSetterFunc={(value) => {
                  sessionStorageInit();
                  navigate(
                    `${route.user_info}?page=1&groupId=${selectedGroupId}&sort=${value}&perPage=${selectedRowsPerPage}&keyword=${keyword}`
                  );
                }}
              />
              <SelectBoxValue
                isMiddle={true}
                selectedValue={selectedRowsPerPage}
                isOpen={rowsPerPageListBoxOpen}
                wrapperHandler={() => {
                  setRowsPerPageListBoxOpen(!rowsPerPageListBoxOpen);
                }}
                itemList={rowsPerPageList}
                selectedValueSetterFunc={(value) => {
                  sessionStorageInit();
                  navigate(
                    `${route.user_info}?page=1&groupId=${selectedGroupId}&sort=${selectedSort}&perPage=${value}&keyword=${keyword}`
                  );
                }}
              />
            </div>
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && isWriteAuthority && (
            <ListTopButtonGroup
              setButtonGroupOpen={setButtonGroupOpen}
              setAlarmPopupOpen={setAlarmPopupOpen}
              setSMSPopupOpen={setSMSPopupOpen}
              getMemberList={getMemberList}
              normalGroupList={normalGroupList}
              setSelectedGroupValue={setSelectedGroupValue}
              userCheckedIdList={checkedListStorage}
              sessionStorageInit={sessionStorageInit}
              selectedGroupId={selectedGroupId}
              initRoute={initRoute}
            />
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="61px" />
              {/* 이름/아이디(이메일) */}
              <col width="224px" />
              {/* 연령/성별 */}
              <col width="92px" />
              {/* 그룹 */}
              <col width="122px" />
              {/* 회원등급/레벨 */}
              <col width="115px" />
              {/* 누적 구매 */}
              <col width="136px" />
              {/* 보유 포인트 */}
              <col width="195px" />
              {/* 보기 */}
              <col width="99px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // 배열 병합 및 중복 제거
                        const mergedArray = [
                          ...userInfoList,
                          ...checkedListStorage,
                        ].reduce((acc, current) => {
                          const existingItem = acc.find(
                            (item) => item.id === current.id
                          );
                          if (!existingItem) {
                            acc.push(current);
                          }
                          return acc;
                        }, []);

                        setCheckedListStorage(mergedArray);
                      } else {
                        const idsToExclude = new Set(
                          userInfoList.map((item) => item.id)
                        );
                        const filteredArray = checkedListStorage.filter(
                          (item) => !idsToExclude.has(item.id)
                        );

                        setCheckedListStorage(filteredArray);
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    이름/아이디(이메일)
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    연령/성별
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    그룹
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    회원등급/레벨
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                      textAlign: "right",
                    }}
                  >
                    누적 구매
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                      textAlign: "right",
                      paddingRight: "56px",
                    }}
                  >
                    보유 포인트
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    보기
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {userInfoList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "59px",
                      padding: "20px 0px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={checkedListStorage.some(
                          (item02) => item02.id === item.id
                        )}
                        onChange={() => {
                          if (
                            checkedListStorage.length > 0 &&
                            checkedListStorage.some(
                              (item02) => item02.id === item.id
                            )
                          ) {
                            let temp = checkedListStorage.filter(
                              (item02) => item02.id !== item.id
                            );
                            setCheckedListStorage(temp);
                          } else {
                            setCheckedListStorage([
                              item,
                              ...checkedListStorage,
                            ]);
                          }
                        }}
                      />
                    </Td>
                    <Td>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <TableText
                          style={{
                            maxWidth: 166,
                          }}
                        >
                          {item.name}
                        </TableText>
                        <TableText
                          style={{
                            maxWidth: 166,
                          }}
                        >
                          {item.email}
                        </TableText>
                      </div>
                    </Td>
                    <Td>
                      <TableText>
                        {item.age}/{item.gender === "male" ? "남" : "여"}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          maxWidth: "94px",
                          display: "-webkit-box",
                          WebkitBoxOrient: "vertical",
                          wordBreak: "normal",
                          whiteSpace: "normal",
                          WebkitLineClamp: 2, // 2줄부터 ... 표시
                        }}
                      >
                        {item?.groupList && item?.groupList?.length > 0
                          ? item.groupList.map((group, index02) => {
                              return (
                                <span key={index02}>
                                  {group.title}
                                  {index02 !== item.groupList.length - 1 &&
                                    ", "}
                                </span>
                              );
                            })
                          : "그룹 없음"}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {cMembershipList[item.membership]}/Lv.
                        {item.writingLevel}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          maxWidth: "136px",
                          textAlign: "right",
                        }}
                      >
                        {item.purchaseCount}회/
                        {formatNumberWithCommas(item.purchaseAmount)}원
                      </TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          maxWidth: "99px",
                          marginLeft: 40,
                          textAlign: "right",
                        }}
                      >
                        {Number(item.totalPoint).toLocaleString()}P
                      </TableText>
                    </Td>
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          navigate(`${route.user_info_detail}/${item.id}`);
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>

          {userInfoList.length > 0 ? null : <Empty />}

          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.user_info}
            queryString={`groupId=${selectedGroupId}&sort=${selectedSort}&perPage=${selectedRowsPerPage}&keyword=${keyword}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {/* 그룹 정보 수정 팝업 */}
      {groupPopupOpen && (
        <GroupManagePopup
          setPopupOpen={setGroupPopupOpen}
          selectedGroupValue={selectedGroupValue}
          getNormalGroupList={getNormalGroupList}
          getOperateGroupList={getOperateGroupList}
        />
      )}

      {/* 알림 보내기 */}
      {alarmPopupOpen && (
        <AlarmSendPopup
          setPopupOpen={setAlarmPopupOpen}
          userCheckedIdList={checkedListStorage}
          getMemberList={getMemberList}
          sessionStorageInit={sessionStorageInit}
          setButtonGroupOpen={setButtonGroupOpen}
        />
      )}

      {/* SMS 보내기 */}
      {smsPopupOpen && (
        <SMSSendPopup
          setPopupOpen={setSMSPopupOpen}
          userCheckedIdList={checkedListStorage}
          getMemberList={getMemberList}
          sessionStorageInit={sessionStorageInit}
          setButtonGroupOpen={setButtonGroupOpen}
        />
      )}
    </>
  );
};

export default UserInfo;

const SubSideBarFooter = styled.div.attrs((props) => {})`
  margin-top: 5px;
  width: 100%;
  height: 38px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0px 16px;
  border-top: 0.5px solid rgba(255, 255, 255, 0.12);
`;

const SubSideBarFooterText = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: #aaa;
  cursor: pointer;
`;
